import { IApplicationState } from '../../../common/types/redux';

export const selectActiveFeature = (state: IApplicationState) => {
  return state.map.selection?.feature ?? null;
};
